module.exports = __webpack_public_path__ + "img/google-white.8d6f19ac.svg";